import React, { Component } from 'react';
import { Spin } from 'antd';

import './LoadingScreen.scss';

export default class LoadingScreen extends Component {
    render() {
        const { loadingText } = this.props;

        return (
            <div className="LoadingScreen">
            	<Spin size="large" tip={loadingText}/>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/LoadingScreen/LoadingScreen.js